import ComingSoon from "@/pages/common/ComingSoon";

export default function Reportes() {
  return (
    <ComingSoon
      icon="ri-bar-chart-2-line"
      title="Reportes"
      description="Descarga el resumen financiero, compras, ventas, gastos, devoluciones e inventario en PDF y CSV."
      hint="Los reportes descargables se activarán en una fase posterior del proyecto."
    />
  );
}